<template>
  <div class="mt-8 text-center space-y-1" :class="wrapperClass">
    <div
      v-if="badgeText"
      class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full mb-2"
      :class="[badgeBgClass, badgeBorderClass, badgeTextColorClass]"
    >
      <i v-if="badgeIconClass" :class="badgeIconClass" class="block"></i>
      <span :class="badgeLabelClass">{{ badgeText }}</span>
    </div>
    <h3 v-if="title" class="text-xl font-serif font-medium leading-tight" :class="titleClass">{{ title }}</h3>
    <p v-if="subtitle" class="text-xs font-medium" :class="subtitleClass">{{ subtitle }}</p>
  </div>
</template>

<script setup>
defineProps({
  badgeText: { type: String, default: '' },
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  badgeIconClass: { type: String, default: 'pr pr-tick-square' },
  badgeBgClass: { type: String, default: 'bg-[#ecd79f]/10' },
  badgeBorderClass: { type: String, default: 'border border-[#ecd79f]/20' },
  badgeTextColorClass: { type: String, default: 'text-[#ecd79f]' },
  badgeLabelClass: { type: String, default: 'text-[10px] font-bold tracking-wider uppercase' },
  titleClass: { type: String, default: 'text-[#f2f4f4]' },
  subtitleClass: { type: String, default: 'text-white/40' },
  wrapperClass: { type: String, default: '' }
});
</script>
